jQuery(document).ready(function ($) {
    $('.acco-title').click(function () {
        const $accordion = $(this).closest('.accordion-wrp');
        const $content = $accordion.find('.acco-content');

        // Close all other open accordions
        $('.accordion-wrp').not($accordion).removeClass('active').find('.acco-content').slideUp();

        // Toggle the clicked accordion
        if ($accordion.hasClass('active')) {
            $accordion.removeClass('active');
            $content.slideUp(); // Collapse with animation
        } else {
            $accordion.addClass('active');
            $content.slideDown(); // Expand with animation
        }
    });
});

document.addEventListener('DOMContentLoaded', function () {
  const sliderWrapper = document.querySelector('.slider-wrapper');
  const sliderItems = document.querySelectorAll('.product-slider-item');
  const prevButton = document.querySelector('.slider-nav.prev');
  const nextButton = document.querySelector('.slider-nav.next');

  let slideIndex = 0; // Current slide index
  const totalSlides = sliderItems.length;

  function updateSlider() {
    const itemWidth = sliderItems[0].offsetWidth; // Width of one slide
    sliderWrapper.style.transform = `translateX(-${slideIndex * itemWidth}px)`; // Move wrapper
  }

  // Event listeners for navigation
  nextButton.addEventListener('click', () => {
    slideIndex = (slideIndex + 1) % totalSlides; // Wrap around at the end
    updateSlider();
  });

  prevButton.addEventListener('click', () => {
    slideIndex = (slideIndex - 1 + totalSlides) % totalSlides; // Wrap around at the start
    updateSlider();
  });

  // Initialize the slider
  updateSlider();


});
